import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=3644b5e6&"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts&"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports